"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixDisabledAttributeToPseudoStateInAst = exports.fixDisabledAttributeToPseudoStateInCss = void 0;
var tslib_1 = require("tslib");
var postcss_1 = require("postcss");
// This css fixer is a fix (workaround) for https://jira.wixpress.com/browse/STYL-877
/** DISCLAIMER - this script does not support multiple selector inside rules and aim to fix stylable-editor output css only */
var fixDisabledAttributeToPseudoStateInCss = function (css) {
    if (css.includes('[disabled]')) {
        var ast = (0, postcss_1.parse)(css);
        fixDisabledAttributeToPseudoStateInAst(ast);
        return ast.toString();
    }
    else {
        return css;
    }
};
exports.fixDisabledAttributeToPseudoStateInCss = fixDisabledAttributeToPseudoStateInCss;
function fixDisabledAttributeToPseudoStateInAst(ast) {
    var e_1, _a;
    ast.walkRules(/\[disabled\]/, function (rule) {
        rule.selector = rule.selector.replace(/\[disabled\]/g, ':disabled');
    });
    var groups = {};
    ast.walkRules(/:disabled/, function (rule) {
        groups[rule.selector] = groups[rule.selector] || new Map();
        if (!rule.parent) {
            return;
        }
        var bucket = groups[rule.selector].get(rule.parent);
        if (!bucket) {
            groups[rule.selector].set(rule.parent, (bucket = []));
        }
        bucket.push(rule);
    });
    try {
        for (var _b = tslib_1.__values(Object.values(groups)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var rulesByParent = _c.value;
            rulesByParent.forEach(function (rules) { return mergeShallowRules(rules); });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
exports.fixDisabledAttributeToPseudoStateInAst = fixDisabledAttributeToPseudoStateInAst;
function mergeShallowRules(rules) {
    var e_2, _a;
    var decls = new Map();
    if (rules.length === 1) {
        return;
    }
    var lastRule = rules[0];
    for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        try {
            for (var _b = (e_2 = void 0, tslib_1.__values(rule.nodes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var decl = _c.value;
                if (decl.type === 'decl') {
                    if (decls.has(decl.prop)) {
                        decls.delete(decl.prop);
                    }
                    decls.set(decl.prop, decl);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (i !== rules.length - 1) {
            rule.remove();
        }
        lastRule = rule;
    }
    lastRule.nodes = Array.from(decls.values());
}
//# sourceMappingURL=fix-disabled-attribute.js.map